import { combineReducers } from 'redux'

import auth from './auth'
import feedbackForm from './feedbackForm'
import feedbackFormTemplates from './feedbackFormTemplates'
import response from './response'
import templates from './templates'
import customers from './customers'
import sms from './sms'
import contentStudio from './contentStudio'
import balanceHistory from './balanceHistory'
import feedbacks from './feedbacks'
import dashboard from './dashboard'
import employee from './employee'
import generateReport from './generateReport'
import settings from './settings'
import subscriptions from './subscriptions'
import members from './members'
import tickets from './tickets'

export default combineReducers({
    auth,
    dashboard,
    employee,
    feedbackForm,
    feedbackFormTemplates,
    response,
    templates,
    customers,
    sms,
    contentStudio,
    balanceHistory,
    feedbacks,
    generateReport,
    settings,
    subscriptions,
    members,
    tickets,
})
